import React from "react";
import Table from "../components/tables/bvn_count/Table";
import Filters from "../components/Filters/Filters";

const BvnCount = () => {
  return (
    <section>
      <Filters />
      <section className="py-10">
        <Table />
      </section>
    </section>
  );
};

export default BvnCount;
